export default __webpack_public_path__ + "static/media/checkIcon.40c82dcd.svg";